import axios from "axios";

export const createPublicOrder = async (payload, token = null) => {
  const headers = {};
  if (token) headers["Authorization"] = `Bearer ${token}`;
  
  const response = await axios.post(
    `https://app.afrodisemusic.com/api/v1/storefront/checkout/`,
    payload,
    { headers }
  );
  return response.data;
};

export const getOrderStatus = async (orderNumber) => {
  const response = await axios.get(
    `https://app.afrodisemusic.com/api/v1/storefront/checkout/${orderNumber}/status/`
  );
  return response.data;
};